import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=65dc063b&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=65dc063b&prod&scoped=true&lang=css&"
import style1 from "./withdraw.vue?vue&type=style&index=1&id=65dc063b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc063b",
  null
  
)

export default component.exports